import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { useUserStore } from "@/store/user-store";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const colorPalette = [
  '#ef4444', '#f97316', '#f59e0b', '#eab308', '#84cc16',
  '#22c55e', '#10b981', '#14b8a6', '#06b6d4', '#0ea5e9',
  '#3b82f6', '#6366f1', '#8b5cf6', '#a855f7', '#d946ef',
  '#ec4899', '#f43f5e',
];

export function getAvatarColor(identifier: string): string {
  if (!identifier) {
    return colorPalette[0];
  }
  
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    const char = identifier.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32bit integer
  }
  
  const index = Math.abs(hash) % colorPalette.length;
  return colorPalette[index];
}


export function formatUserDateTime(dateString: string): string {
    const { user } = useUserStore.getState();
    const timeZone = user?.timezone?.zone;

    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // Get current time in same timezone (approx)
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.abs(diffMs / (1000 * 60 * 60));

    // If difference > 24 hours → show full date, else just show time
    const options: Intl.DateTimeFormatOptions =
        diffHours >= 24
            ? {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
              }
            : {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
              };

    if (timeZone) {
        options.timeZone = timeZone;
    }

    try {
        const formatted = new Intl.DateTimeFormat('en-US', options).format(date);
        return formatted;
    } catch (e) {
        console.error("Failed to format date with timezone:", e);
        return date.toLocaleString('en-US', { ...options, timeZone: undefined });
    }
}

// export function formatUserDateTime(dateString: string): string {
//     const { user } = useUserStore.getState();
//     const timeZone = user?.timezone?.zone;

//     if (!dateString) return 'N/A';

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return 'Invalid Date';

//     const options: Intl.DateTimeFormatOptions = {
//         year: 'numeric',
//         month: '2-digit',
//         day: '2-digit',
//         hour: '2-digit',
//         minute: '2-digit',
//         hour12: true,
//     };

//     if (timeZone) {
//         options.timeZone = timeZone;
//     }

//     try {
//         return new Intl.DateTimeFormat('en-US', options).format(date);
//     } catch (e) {
//         console.error("Failed to format date with timezone:", e);
//         // Fallback to local time if timezone is invalid
//         return date.toLocaleString('en-US', { ...options, timeZone: undefined });
//     }
// }


export function getFlagEmoji(countryCode:string) {
  if (!countryCode) return '';

  // Convert to uppercase (e.g. "us" → "US")
  const code = countryCode.toUpperCase();

  // Each letter is converted to a regional indicator symbol
  // 'A'.charCodeAt(0) = 65, '🇦' = 127462
  // Formula: 127397 + letter.charCodeAt(0)
  return [...code]
    .map(char => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('');
}
